import { HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, catchError } from 'rxjs';
import { environment } from '#environments';

/**
 * Intercepts HTTP responses from the Centaur API and redirects to /403 when the
 * server returns 403 Forbidden.
 *
 * This covers two scenarios:
 *  1. No valid Azure role in the JWT  (FallbackPolicy / RoleAuthorizationHandler rejects)
 *  2. UserProfile.Status == "Deprovisioned"  (DeprovisionedUserMiddleware rejects)
 *
 * Returning EMPTY prevents the error from bubbling to the GlobalErrorHandler,
 * which would otherwise show a generic toast on top of the navigation.
 *
 * 401 Unauthorized is intentionally NOT handled here — MSAL's MsalInterceptor already
 * acquires a fresh token and retries before the 401 reaches application code.
 */
export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  // Only intercept calls to our own API — leave Graph and other third-party URLs alone.
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error) => {
      if (error?.status === HttpStatusCode.Forbidden) {
        router.navigate(['/403']);
        return EMPTY;
      }
      throw error;
    }),
  );
};
